// src/components/SortDrawer/index.js
// Mobile bottom sheet for sorting products. Mirrors ApparelFilterDrawer's
// structure/animations and reuses its CSS classes (plus the radio styles
// from ApparelFilters) so it looks and feels identical to the Filter sheet.
//
// Only offers sort options backed by a real product field (price) — there is
// no "newest"/"popularity" data anywhere in the product payload, so those
// options are intentionally not offered.
import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import '../ApparelFilterDrawer/index.css';
import '../ApparelFilters/index.css';

export const SORT_OPTIONS = [
  { value: 'relevance', label: 'Relevance' },
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'price_desc', label: 'Price: High to Low' },
];

const SortDrawer = ({ isOpen, onClose, sortBy, onChangeSortBy }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 300); // match transition duration
  };

  if (!isOpen && !isClosing) return null;

  return (
    <>
      <div
        className={`filter-drawer-overlay ${isClosing ? 'closing' : ''}`}
        onClick={handleClose}
      />
      <div className={`filter-drawer-container ${isClosing ? 'closing' : ''}`}>
        <div className="filter-drawer-header">
          <h3>Sort By</h3>
          <button className="filter-drawer-close" onClick={handleClose}>
            <X size={24} />
          </button>
        </div>

        <div className="filter-drawer-content">
          <div className="apparel-filters-sidebar">
            <div className="filter-section border-bottom-0">
              <div className="filter-section-content">
                {SORT_OPTIONS.map(opt => (
                  <label key={opt.value} className="filter-radio-label">
                    <input
                      type="radio"
                      name="sortBy"
                      checked={sortBy === opt.value}
                      onChange={() => onChangeSortBy(opt.value)}
                    />
                    <span className="radio-custom"></span>
                    <span className="radio-text">{opt.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="filter-drawer-footer">
          <button className="filter-drawer-apply-btn" onClick={handleClose}>
            Apply
          </button>
        </div>
      </div>
    </>
  );
};

export default SortDrawer;
